import { createActions, createReducer } from 'reduxsauce'

import IndicadorService from '_/servicos/IndicadorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaIndicadorInicio: [],
    buscaIndicadorSucesso: ['indicador'],
    buscaIndicadorErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaIndicador = () => {
    return dispatch => {
        dispatch(Creators.buscaIndicadorInicio())
        let serv = new IndicadorService()
        return serv
            .getIndicador()
            .then(response => dispatch(Creators.buscaIndicadorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaIndicadorErro(error)))
    }
}

const buscaIndicadorInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaIndicadorErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaIndicadorSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.indicador, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_INDICADOR_INICIO]: buscaIndicadorInicio,
    [Types.BUSCA_INDICADOR_ERRO]: buscaIndicadorErro,
    [Types.BUSCA_INDICADOR_SUCESSO]: buscaIndicadorSucesso,
})
